import React, { useEffect, useState } from "react";
import Image900 from "./Image900.js";
import Images360 from "./Images360.js";
import ImagesPNG from "./ImagesPNG.js";
import { UsePictures } from "./UsePictures";
import { useNavigate, useLocation } from "react-router-dom";
import Detail from "../../main/detail/Detail";
import { Typography, Button, Box } from "@mui/material";
import { rsActiveMenu } from "../../RecoilStates.js";
import { useRecoilState } from "recoil";

export default function EditPicture() {
  const [msActiveMenu, setMsActiveMenu] = useRecoilState(rsActiveMenu);
  const navigate = useNavigate();
  const location = useLocation();
  const [state, setState] = useState();
  const { getPictureByID } = UsePictures();

  useEffect(() => {
    if (location.state && location.state.id) {
      getPictureByID(location.state.id, (pictureRes) => {
        setState(pictureRes);
      });
    }
  }, []);

  return (
    <Detail
      breadChilds={{
        title: "محصولات ",
        childs: [
          { name: msActiveMenu.pageTitle, url: "/productimages" },
          { name: "ویرایش تصاویر", url: "/productimages/editpicture" },
        ],
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          p: 1,
          mb: 2,
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <Typography variant="body1">
            کد محصول : ({location.state.id}) /
          </Typography>
          <Typography variant="body1">
            نام محصول : {location.state.name}
          </Typography>
        </Box>
        <Button
          variant="text"
          color="secondary"
          onClick={() => {
            navigate("/productimages", {
              state: { ...location.state, isBack: true },
              replace: true,
            });
          }}
        >
          بازگشت
        </Button>
      </Box>

      {state && <Image900 model={state} />}
      {state && <Images360 model={state} />}
      {state && <ImagesPNG model={state} />}
    </Detail>
  );
}
